export enum PdfContentName {
  TASK_DETAILS = 'taskDetails',
  TASK_DESCRIPTION = 'taskDescription',
  TASK_TIMELINE = 'taskTimeline',
  TASK_ATTACHMENTS = 'taskAttachments'
}
